module.exports = __webpack_public_path__ + "static/img/M-4.d0a0354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mzhongfu/M-4.png
// module id = nbE3
// module chunks = 0